/*
format pre conversation
- screening question
- 

*/

const conversationData = {
  "conversations": [
    {
      "scene": 1,
      "name": "mo",
      "activity": "Gaming",
      "conversation": [
        {
          "id": 0,
          "observation": "🎮 [Mo zit gebogen over zijn controller, helemaal opgegaan in zijn game.]"
        },
        {
          "id": 1,
          "question": "👋 Hoi Mo, ...",
          "follow-up": [
            { "text": "wat ben je aan het doen?", "response": "... gamen natuurlijk 👾", "next": 2 },
            { "text": "wordt eens wakker!", "response": "... huh wat? O, hoi 🫩", "next": 2 },
            { "text": "Mo?", "response": "... wacht even... bijna... yes 🎯! Hoi!", "next": 2 }
          ]
        },
        {
          "id": 2,
          "question": "Je ziet er moe uit...",
          "follow-up": [
            {  "text": "hoe lang ben je al aan het gamen?", "response": "Nog maar net! Ik begon na school", "next": 3 },
            {  "text": "gaat alles goed op school?", "response": "Ja hoor... gewoon even ontspannen na school", "next": 3 },
            {  "text": "wanneer heb je voor het laatst pauze gehouden?", "response": "Pauze? Ik ben net begonnen na school!", "next": 3 }
          ]
        },
        {
          "id": 3,
          "question": "Mo... dat was 3 uur geleden . Zullen we wat anders doen?",
          "follow-up": [
            { "text": "Voetballen buiten?", "next": 4, "response": "Eh... misschien. Eerst dit level nog afmaken?" },
            { "text": "Even wandelen?", "next": 3, "response": "Nah, ik zit net lekker" },
            { "text": "Gewoon wat kletsen?", "next": 3, "response": "Kan ook tijdens gamen toch?" }
          ]
        },
        {
          "id": 4,
          "question": "Dan mag jij…",
          "follow-up": [
            { "text": "de keeper zijn", "next": 5, "response": "... okay, misschien..." },
            { "text": "de scheidsrechter zijn", "next": 3, "response": "... nee, saai" },
            { "text": "de spits zijn", "next": 3, "response": "… nee, veel te veel rennen" }
          ]
        },
        {
          "id": 5,
          "question": "Kom mee!",
          "follow-up": [
            { "text": "Gamen kan ook als het regent!", "next": 6, "response": "Je hebt gelijk. Laten we gaan!" },
            { "text": "Je mag mijn handschoenen lenen", "next": 6, "response": "Je nieuwe handschoenen? Tof!" },
            { "text": "Voetballen is goed voor je!", "next": 6, "response": "Okay wijsneus, we gaan al." }
          ]
        },
        {
          "id": 6,
          "question": "Fijn dat je meegaat! Ik heb een tip voor je:",
          "follow-up": [
            { "text": "Zet een timer als je gaat gamen, dan vergeet je de tijd niet.", "response": "Ja, dat is slim. Dan merk ik het tenminste!", "next": null },
            { "text": "Neem elke 30 minuten een kleine pauze van je scherm.", "response": "Goed idee, dan blijf ik scherp in m'n game!", "next": null },
            { "text": "Plan van tevoren wanneer je gaat gamen en wanneer je stopt.", "response": "Ja, dan kan ik ook andere leuke dingen doen!", "next": null }
          ]
        }
      ]
    },
    {
      "scene": 2,
      "name": "julia",
      "activity": "Scrollen",
      "conversation": [
        {
          "id": 0,
          "observation": "📱 [Julia zit nog in haar pyjama terwijl ze eindeloos door TikTok scrolt.] 😴"
        },
        {
          "id": 1,
          "question": "👋 Hoi Julia, ...",
          "follow-up": [
            { "text": "wat ben je aan het doen?", "response": "O hoi... gewoon even TikTok kijken 📱", "next": 2 },
            { "text": "zit je nog in je pyjama?", "response": "Ja... ik was gisteravond laat op en nu ben ik zo moe 😪", "next": 2 },
            { "text": "Julia? Hallo?", "response": "Sorry! Ik zag je niet. Zat even op m'n telefoon 😅", "next": 2 }
          ]
        },
        {
          "id": 2,
          "question": "Je ziet er heel moe uit... 😔",
          "follow-up": [
            { "text": "hoe lang ben je al aan het scrollen?", "response": "Ik ging gisteravond even scrollen voor het slapen. Voor ik het wist was het heel laat! 🕐", "next": 3 },
            { "text": "wanneer ben je gaan slapen?", "response": "Veel te laat... ik bleef maar scrollen en kon niet stoppen 😵‍💫", "next": 3 },
            { "text": "voel je je wel lekker zo?", "response": "Niet echt... ik ben zo moe van te weinig slaap 🥱", "next": 3 }
          ]
        },
        {
          "id": 3,
          "question": "Zullen we… 🤔",
          "follow-up": [
            { "text": "Gaan voetballen ⚽", "response": "... nee, veel te saai 😑", "next": 3 },
            { "text": "Een proefje doen 🧪", "response": "... misschien, eerst dit filmpje afkijken 📱", "next": 4 },
            { "text": "Iets tekenen ✏️", "response": "... nee, veel te veel moeite 😩", "next": 3 }
          ]
        },
        {
          "id": 4,
          "question": "Dan mag jij… 😊",
          "follow-up": [
            { "text": "... het proefje kiezen van de NEMO-site 🔬", "response": "... okay, misschien... 🤷‍♀️", "next": 5 },
            { "text": "... maken we een schuimvulkaan 🌋", "response": "... nee, dat deed ik in groep 3 🙄", "next": 3 },
            { "text": "... kunnen we kijken of je telefoon kan drijven 📱🏊", "response": "... nee, doe normaal! 😤", "next": 3 }
          ]
        },
        {
          "id": 5,
          "question": "Zullen we… ⚡",
          "follow-up": [
            { "text": "buiten bliksem maken ⚡", "response": "Ik zou niet weten hoe, maar klinkt leuk. 🤩", "next": 6 },
            { "text": "een geheimschrift maken 🕵️‍♀️", "response": "Ja! En een speurtocht! 🗺️", "next": 6 },
            { "text": "een katapult maken 🏹", "response": "Ja, en dan brood naar eendjes schieten. 🦆🍞", "next": 6 }
          ]
        },
        {
          "id": 6,
          "question": "Ik heb een tip voor je! 💡",
          "follow-up": [
            { "text": "Zet je telefoon uit voor je gaat slapen, dan slaap je beter. 😴", "response": "Ja, dat probeer ik! Misschien helpt het tegen die vermoeidheid 💤", "next": null },
            { "text": "Zet een timer voor scrollen, net als bij gamen. ⏰", "response": "Goed idee! Dan verdwaal ik niet meer in die oneindige feed 🌀", "next": null },
            { "text": "Zoek bewust leuke video's op, in plaats van alleen maar scrollen. 🎯", "response": "Ja! Dan kijk ik tenminste dingen die ik écht wil zien 👍", "next": null }
          ]
        }
      ]
    },
    {
      "scene": 3,
      "name": "sam",
      "activity": "VR",
      "conversation": [
        {
          "id": 0,
          "observation": "🥽 [Sam staat midden in de kamer met een VR-bril op, zwaaiend met controllers. Hij lijkt helemaal opgegaan in een andere wereld.] ✨"
        },
        {
          "id": 1,
          "question": "👋 Hoi Sam, ...",
          "follow-up": [
            { "text": "wat ben je aan het doen?", "response": "O! Ik loop door een magisch bos. Zo mooi! 🌳✨", "next": 2 },
            { "text": "zie je me wel staan?", "response": "Sorry, had je niet gehoord! Ik zit in VR 🥽", "next": 2 },
            { "text": "welke wereld ben je in?", "response": "Een fantasiewereld! Hier zijn draken en kastelen! 🐉🏰", "next": 2 }
          ]
        },
        {
          "id": 2,
          "question": "Het ziet er wel gaaf uit! Maar... 🤔",
          "follow-up": [
            { "text": "mis je de echte wereld niet?", "response": "Soms wel, maar hier is alles perfect 🌟", "next": 3 },
            { "text": "hoe lang ben je hier al?", "response": "Geen idee... tijd gaat hier anders 🕐", "next": 3 },
            { "text": "voel je de zon hier ook?", "response": "Nee, maar er is hier magisch licht! ✨💫", "next": 3 }
          ]
        },
        {
          "id": 3,
          "question": "Zullen we samen... 🤝",
          "follow-up": [
            { "text": "naar het echte bos? Dan ruiken we ook de bomen 🌲", "response": "Hmm... maar hier stinkt het tenminste niet 😅", "next": 4 },
            { "text": "een echt avontuur beleven buiten? 🏞️", "response": "Wat voor avontuur dan? Dit is al spannend 😮", "next": 4 },
            { "text": "kijken of echt zonlicht lekkerder voelt? ☀️", "response": "Oké, misschien heel even dan... 🤔", "next": 4 }
          ]
        },
        {
          "id": 4,
          "question": "Maar als we nu eens… 🤗",
          "follow-up": [
            { "text": "Een speurtocht gaan uitzetten 🗺️", "response": "... okay, misschien... 🤷‍♂️", "next": 5 },
            { "text": "Vogels gaan spotten 🐦", "response": "... hier zijn vliegende draken. 🐉", "next": 3 },
            { "text": "Een hut gaan bouwen 🏠", "response": "... ik houd niet van bouwen. 😒", "next": 3 }
          ]
        },
        {
          "id": 5,
          "question": "Kom mee! 🏃‍♂️",
          "follow-up": [
            { "text": "Ik heb al touwtjes en krijt 🎨", "response": "Okay, ik heb al een route in gedachten 🗺️", "next": 6 },
            { "text": "Laten we aanwijzingen verstoppen 🕵️", "response": "Dat klinkt leuk! 😄 \n\n", "next": 6 },
            { "text": "Kijken wie zometeen onze speurtocht wil doen 👥", "response": "Ja, laten we bij de speeltuin kijken! 🛝", "next": 6 }
          ]
        },
        {
          "id": 6,
          "question": "Hey Sam, fijn dat je mee naar buiten gaat. Ik heb een tip voor je: 💡",
          "follow-up": [
            { "text": "Zet een timer bij VR, dan vergeet je de tijd niet. ⏰", "response": "Ja, dat ga ik doen. Dan kan ik ook andere dingen doen! 👍", "next": null },
            { "text": "Plan echte activiteiten in, net als VR-sessies. 📅", "response": "Goed idee! Dan heb ik iets om naar uit te kijken 😊", "next": null },
            { "text": "Vraag vrienden mee voor echte avonturen. 👫", "response": "Ja! Samen is alles leuker, ook in het echt 🤗", "next": null }
          ]
        }
      ]
    },
    {
      "scene": 4,
      "name": "liam",
      "activity": "Chatten",
      "conversation": [
        {
          "id": 0,
          "observation": "💬 [Liam zit met zijn telefoon in zijn handen en tikt constant berichtjes.] 🔔"
        },
        {
          "id": 1,
          "question": "👋 Hoi Liam, ...",
          "follow-up": [
            { "text": "wat ben je aan het doen?", "response": "O hoi! Even m'n berichtjes beantwoorden 💬", "next": 2 },
            { "text": "druk bezig zo te zien?", "response": "Ja! Iedereen appt tegelijk vandaag 📱", "next": 2 },
            { "text": "heb je even tijd om te praten?", "response": "Ja hoor, ik app wel tegelijk 😅", "next": 2 }
          ]
        },
        {
          "id": 2,
          "question": "Wow, dat zijn veel meldingen! 🔔",
          "follow-up": [
            { "text": "Ben je bang iets te missen?", "response": "Ja! Stel je voor dat er iets leuks gebeurt 😰", "next": 3 },
            { "text": "Zijn het allemaal belangrijke berichten?", "response": "Nou... niet allemaal, maar je weet maar nooit 🤷‍♂️", "next": 3 },
            { "text": "Vind je het stressig, al die meldingen?", "response": "Soms wel, maar ik wil niemand negeren 😬", "next": 3 }
          ]
        },
        {
          "id": 3,
          "question": "Zullen we eens... 🤔",
          "follow-up": [
            { "text": "échte vrienden opzoeken, zonder telefoon? 👫", "response": "Hmm, maar hoe weten ze dan waar ik ben? 😟", "next": 4 },
            { "text": "samen iets leuks doen hier? 🎮", "response": "Oké, maar mag ik even snel antwoorden eerst? 📱", "next": 4 },
            { "text": "kijken wie écht belangrijk is om te antwoorden? 🎯", "response": "Dat is best moeilijk... iedereen verwacht antwoord 😓", "next": 4 }
          ]
        },
        {
          "id": 4,
          "question": "Of… 💡",
          "follow-up": [
            { "text": "Aanbellen om kinderpostzegels te verkopen 📮", "response": "... hmmm. 🤔", "next": 5 },
            { "text": "Belletje trekken 🔔", "response": "... nee, want iedereen heeft een video deurbel 📹", "next": 3 },
            { "text": "Koekjes bakken en verkopen langs de deur 🍪", "response": "... nee, veels te veel gedoe 😒", "next": 3 }
          ]
        },
        {
          "id": 5,
          "question": "Kom op! 💪",
          "follow-up": [
            { "text": "Kinderpostzegels is voor het goeie doel ❤️", "response": "Okay, ik ben overtuigd 😊", "next": 6 },
            { "text": "De groep die de meeste zegels verkoopt wint een prijs 🏆", "response": "Oké, dat klinkt tof! 🤩", "next": 6 },
            { "text": "Het thema is tegen eenzaamheid 🤝", "response": "... tegen alleen in je virtuele bos rondlopen? 🌳", "next": 6 }
          ]
        },
        {
          "id": 6,
          "question": "Fijn dat je meegaat! Ik heb een tip voor je: 💡",
          "follow-up": [
            { "text": "Zet meldingen uit. Dan bepaal jij wanneer je kijkt naar berichten. 🔕", "response": "Dat is spannend, maar misschien wel rustiger! 😌", "next": null },
            { "text": "Plan vaste tijden om te appen, net als huiswerk maken. ⏰", "response": "Goed idee! Dan hoef ik niet constant te checken 📱", "next": null },
            { "text": "Vraag jezelf af: is dit bericht urgent of kan het wachten? 🤷", "response": "Ja, meestal kan het wel wachten eigenlijk 💭", "next": null }
          ]
        }
      ]
    },
    {
      "scene": 5,
      "name": "louisa",
      "activity": "Bingen",
      "conversation": [
        {
          "id": 0,
          "observation": "📱 [Louisa ligt languit op de bank met een tablet op haar buik. Ze kijkt al uren achter elkaar filmpjes.] 😴"
        },
        {
          "id": 1,
          "question": "👋 Hoi Louisa, ...",
          "follow-up": [
            { "text": "wat ben je aan het kijken?", "response": "O hoi! Gewoon YouTube filmpjes 📹", "next": 2 },
            { "text": "zit je hier al lang?", "response": "Niet zo lang... ik keek gewoon één filmpje 😅", "next": 2 },
            { "text": "vind je het nog leuk wat je kijkt?", "response": "Ja... nou ja, het ene filmpje start het andere 🔄", "next": 2 }
          ]
        },
        {
          "id": 2,
          "question": "Hoe lang kijk je al? 🕐",
          "follow-up": [
            { "text": "Weet je nog wat het eerste filmpje was?", "response": "Eh... iets met katten geloof ik? Nu zie ik kookfilmpjes 🐱➡️👨‍🍳", "next": 3 },
            { "text": "Kies je zelf wat je kijkt?", "response": "Niet echt... YouTube kiest voor mij 🤖", "next": 3 },
            { "text": "Voel je je nog fit zo?", "response": "Eigenlijk niet... ik zit al zo lang stil 😞", "next": 3 }
          ]
        },
        {
          "id": 3,
          "question": "Zullen we iets actiefs doen? 🏃‍♀️",
          "follow-up": [
            { "text": "Zelf iets creatiefs maken in plaats van alleen kijken? 🎨", "response": "Hmm... wat dan? Klinkt wel leuk 🤔", "next": 4 },
            { "text": "Even bewegen, lekker naar buiten? 🌞", "response": "Mwah. Ik zit wel lekker eigenlijk. 😒", "next": 2 },
            { "text": "Een boek lezen samen? 📚", "response": "Geen zin... 😑", "next": 2 }
          ]
        },
        {
          "id": 4,
          "question": "Dan mag jij… ✨",
          "follow-up": [
            { "text": "Een tekening maken en ik schrijf er een verhaal bij ✏️📖", "response": "... okay, misschien... 🤷‍♀️", "next": 5 },
            { "text": "Alles opschrijven wat ik vertel ✍️", "response": "Nou ja, zeg. Schrijf het lekker zelf 😤", "next": 3 },
            { "text": "Een verhaal over mij verzinnen 📝", "response": "Dan kijk ik liever filmpjes 📱", "next": 3 }
          ]
        },
        {
          "id": 5,
          "question": "Kom mee… 📚✨",
          "follow-up": [
            { "text": "Misschien schrijven we wel de nieuwe Harry Potter! ⚡", "response": "Je hebt gelijk, laten we gaan! 🤩", "next": 6 },
            { "text": "Misschien verzinnen we wel de nieuwe Dogman! 🐕", "response": "Haha, dat lijkt me leuk! 😄 \n\n", "next": 6 },
            { "text": "Dan maken we \"Hoe overleef ik de Week van de Mediawijsheid?\" 📱🛡️", "response": "Dat klinkt echt heel… spannend 😏", "next": 6 }
          ]
        },
        {
          "id": 6,
          "question": "Fijn dat je meedoet! Ik heb een tip voor je: 💡",
          "follow-up": [
            { "text": "Zet autoplay uit, dan kies jij bewust wat je kijkt. ⏸️", "response": "Goed idee! Dan verdwaal ik niet meer in eindeloze filmpjes 🌀", "next": null },
            { "text": "Kijk alleen filmpjes die je echt wilt zien. 🎯", "response": "Ja! Dan kijk ik tenminste dingen die ik leuk vind 👍", "next": null },
            { "text": "Neem af en toe pauze om te bewegen. 🏃‍♀️", "response": "Dat ga ik proberen! Dan voel ik me vast fitter 💪", "next": null }
          ]
        }
      ]
    }
  ]
}
/*

Amber Van Der Wal
wel interessant om te vragen naar restricties opgelegd door ouders 
(want dat geeft natuurlijk geen agency, maar beperkt mogelijk wel overuse). 
Bijv time limits, maar veel sociale media hebben nu ook zo'n teen version 
waarbij je ouders bij van alles en nog wat mee kunnen kijken (wie jij volgt, 
wie jou volgen, hoe laat je nog een berichtje hebt gestuurd,e tc) en een max tijd in kunnen stellen



*/


conversationData.conversations[0].reflection = [
  //reflection on situation of gaming overuse
  {"statement": "Game je zelf wel eens?", "scale": ["0️⃣ \n\n nooit", "1️⃣ \n\n heel af en toe", "2️⃣ \n\n af en toe", "3️⃣ \n\n wekelijks", "4️⃣ \n\n dagelijks"]},
  {"statement": "Game je ook wel eens 'te lang'?",  "scale": ["0️⃣ \n\n Nooit", "1️⃣ \n\n Wel eens", "2️⃣ \n\n Soms", "3️⃣ \n\n Best vaak", "4️⃣ \n\n Altijd"]},
  {"statement": "Kun je gemakkelijk stoppen met gamen?", "scale": ["😄 \n\n Prima", "🙂 \n\n Lukt wel", "😐 Neutraal", "😕 \n\n Beetje lastig", "☹️\n\n Heel lastig"]},
  {"statement": "Maak je gebruik van een timer of heb je schermtijd?", "scale": ["🧑‍🧑‍🧒 \n\n Ja, door mijn ouder(s)", "⏳ \n\n Ja, zelf ingesteld", "⌛️ Soms wel", "👾 \n\n Nee, maar wel goed idee", "🕹️\n\n Nee."]}
];
conversationData.conversations[1].reflection = [
  //reflection on situation of scrolling overuse
  {"statement": "Scroll je zelf wel eens op socials?", "scale": ["0️⃣ \n\n nooit", "1️⃣ \n\n heel af en toe", "2️⃣ \n\n af en toe", "3️⃣ \n\n wekelijks", "4️⃣ \n\n dagelijks"]},
  {"statement": "Scroll je ook wel eens 'te lang'?",  "scale": ["0️⃣ \n\n Nooit", "1️⃣ \n\n Wel eens", "2️⃣ \n\n Soms", "3️⃣ \n\n Best vaak", "4️⃣ \n\n Altijd"]},
  {"statement": "Kun je gemakkelijk stoppen met scrollen?", "scale": ["😄 \n\n Prima", "🙂 \n\n Lukt wel", "😐 Neutraal", "😕 \n\n Beetje lastig", "☹️\n\n Heel lastig"]},  
  {"statement": "Maak je gebruik van een timer of heb je schermtijd?", "scale": ["🧑‍🧑‍🧒 \n\n Ja, door mijn ouder(s)", "⏳ \n\n Ja, zelf ingesteld", "⌛️ Soms wel", "👾 \n\n Nee, maar wel goed idee", "🕹️\n\n Nee."]}
];
conversationData.conversations[2].reflection = [
  //reflection on situation of VR overuse
  {"statement": "Speel je zelf wel eens in Virtual Reality (VR)?", "scale": ["0️⃣ \n\n nooit", "1️⃣ \n\n heel af en toe", "2️⃣ \n\n af en toe", "3️⃣ \n\n wekelijks", "4️⃣ \n\n dagelijks"]},
  {"statement": "Zit je soms wel eens 'te lang' in VR?", "scale": ["0️⃣ \n\n Nooit", "1️⃣ \n\n Wel eens", "2️⃣ \n\n Soms", "3️⃣ \n\n Best vaak", "4️⃣ \n\n Altijd"]},
  {"statement": "Kun je gemakkelijk stoppen met gamen in VR?","scale": ["😄 \n\n Prima", "🙂 \n\n Lukt wel", "😐 Neutraal", "😕 \n\n Beetje lastig", "☹️\n\n Heel lastig"]},  
  {"statement": "Gebruik je een timer of heb je schermtijd in VR?", "scale": ["🧑‍🧑‍🧒 \n\n Ja, door mijn ouder(s)", "⏳ \n\n Ja, zelf ingesteld", "⌛️ Soms wel", "👾 \n\n Nee, maar wel goed idee", "🕹️\n\n Nee."]}
];
conversationData.conversations[3].reflection = [
  //reflection on situation of chatting overuse
  {"statement": "Chat jij wel eens met vrienden op bijvoorbeeld WhatsApp?", "scale": ["0️⃣ \n\n nooit", "1️⃣ \n\n heel af en toe", "2️⃣ \n\n af en toe", "3️⃣ \n\n wekelijks", "4️⃣ \n\n dagelijks"]},
  {"statement": "Zit je ook wel eens 'te lang' te chatten?", "scale": ["0️⃣ \n\n Nooit", "1️⃣ \n\n Wel eens", "2️⃣ \n\n Soms", "3️⃣ \n\n Best vaak", "4️⃣ \n\n Altijd"]},
  {"statement": "Kun je gemakkelijk stoppen met chatten?", "scale": ["😄 \n\n Prima", "🙂 \n\n Lukt wel", "😐 Neutraal", "😕 \n\n Beetje lastig", "☹️\n\n Heel lastig"]},  
  {"statement": "Maak je gebruik van een timer of heb je schermtijd voor apps als WhatsApp?", "scale": ["🧑‍🧑‍🧒 \n\n Ja, door mijn ouder(s)", "⏳ \n\n Ja, zelf ingesteld", "⌛️ Soms wel", "👾 \n\n Nee, maar wel goed idee", "🕹️\n\n Nee."]}
];
conversationData.conversations[4].reflection = [
  //reflection on situation of binging overuse
  {"statement": "Kijk je wel eens filmpjes op YouTube of Netflix?", "scale": ["0️⃣ \n\n nooit", "1️⃣ \n\n heel af en toe", "2️⃣ \n\n af en toe", "3️⃣ \n\n wekelijks", "4️⃣ \n\n dagelijks"]},
  {"statement": "Kijk je ook wel eens 'te lang' filmpjes op Youtube of Netflix?",  "scale": ["0️⃣ \n\n Nooit", "1️⃣ \n\n Wel eens", "2️⃣ \n\n Soms", "3️⃣ \n\n Best vaak", "4️⃣ \n\n Altijd"]},
  {"statement": "Vind je het gemakkelijk om te stoppen met bingen?", "scale": ["😄 \n\n Prima", "🙂 \n\n Lukt wel", "😐 Neutraal", "😕 \n\n Beetje lastig", "☹️\n\n Heel lastig"]},  
  {"statement": "Maak je gebruik van een timer of heb je schermtijd voor apps als YouTube of Netflix?", "scale": ["🧑‍🧑‍🧒 \n\n Ja, door mijn ouder(s)", "⏳ \n\n Ja, zelf ingesteld", "⌛️ Soms wel", "👾 \n\n Nee, maar wel goed idee", "🕹️\n\n Nee."]}
];

console.log("Conversations loaded.",conversationData);


export default conversationData;